export const config = (onView, contractNumber, withFilter) => {
  let tableConfig;

  if (contractNumber) {
    tableConfig = [
      {
        name: "Numéro contrat",
        selector: (row) => row.contract_number,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Échéance",
        selector: (row) => row.due_date,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Financement",
        selector: (row) => row.final_amount,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Loyer HT",
        selector: (row) => row.amount_rent,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "TVA /Loyer",
        selector: (row) => row.amount_rent_vat,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Montant Loyer (TTC)",
        selector: (row) => row.amount_rent_rtc,
        sortable: true,
        filterable: withFilter,
        cell: (row) => (row.amount_rent_rtc === 0 ? "" : row.amount_rent_rtc),
      },
      {
        name: "Profit",
        selector: (row) => row.profit,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Capital",
        selector: (row) => row.capital,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Montant restant",
        selector: (row) => row.remaining_amount,
        sortable: true,
        filterable: withFilter,
        minWidth: "120px !important",
        cell: (row) => (row.remaining_amount === 0 ? "" : row.remaining_amount),
      },
    ];
  } else {
    tableConfig = [
      {
        name: "Numéro contrat",
        selector: (row) => row.contract_number,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Montant d'échéance",
        selector: (row) => row.due_amount,
        sortable: true,
        filterable: withFilter,
        cell: (row) => (row.due_amount === 0 ? "" : row.due_amount),
      },
      {
        name: "Nom",
        selector: (row) => row.name,
        sortable: true,
        filterable: withFilter,
      },
      // {
      //   name: "Etat du contrat",
      //   selector: (row) => row.status,
      //   sortable: true,
      // },
      {
        name: "Montant de financement",
        selector: (row) => row.amount,
        sortable: true,
        filterable: withFilter,
        cell: (row) => (row.amount === 0 ? "" : row.amount),
      },
      {
        name: "Matériel",
        selector: (row) => row.project,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Date fin du contrat",
        selector: (row) => row.effective_date,
        sortable: true,
        filterable: withFilter,
      },
      {
        name: "Échéance",
        selector: (row) => row.due_date,
        sortable: true,
        filterable: withFilter,
      },

      // {
      //     name: 'Actions',
      //     selector: row => row.id,
      //     cell: (row) => <Button
      //     view="clear"
      //     variant="dark"
      //     isIconButton
      //     title="View"
      //     onClick={() => onView(row.id)}><RiEyeLine /></Button>,

      // },
    ];
  }

  return tableConfig;
};
